import { Link, NavLink, useLocation } from "react-router-dom";
import userContext from "../Context/userContext";
import { useContext, useState, useEffect, useRef } from "react";
import LogoPlato from "../Comun/LogoPlato";
import { fusionar, useListaCompra } from "../../services/listaCompra";
import "../../styles/NavBar/NavBar.css";

const NavBarP = () => {
  const { user } = useContext(userContext);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const location = useLocation();
  const menuUsuario = useRef(null);

  useEffect(() => {
    setDropdownOpen(false);
    const navbarCollapse = document.getElementById('navbarContent');
    if (navbarCollapse) {
      navbarCollapse.classList.remove('show');
    }
  }, [location]);

  // El menú de usuario se cierra con Escape o al pulsar fuera de él
  useEffect(() => {
    if (!dropdownOpen) return undefined;
    const alPulsarFuera = (e) => {
      if (menuUsuario.current && !menuUsuario.current.contains(e.target)) setDropdownOpen(false);
    };
    const alTeclear = (e) => {
      if (e.key === "Escape") setDropdownOpen(false);
    };
    document.addEventListener("mousedown", alPulsarFuera);
    document.addEventListener("keydown", alTeclear);
    return () => {
      document.removeEventListener("mousedown", alPulsarFuera);
      document.removeEventListener("keydown", alTeclear);
    };
  }, [dropdownOpen]);

  const listaCompra = useListaCompra();
  const productosCompra = fusionar(listaCompra.recetas).length;

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const closeMenu = () => {
    setDropdownOpen(false);
    const navbarCollapse = document.getElementById('navbarContent');
    if (navbarCollapse) {
      navbarCollapse.classList.remove('show');
    }
  };

  // NavLink marca la página actual (clase «active» y aria-current="page")
  const enlace = ({ isActive }) => "nav-link" + (isActive ? " active" : "");

  return (
    <nav className="navbar navbar-expand-lg pt-nav" data-bs-theme="dark" aria-label="Principal">
      <div className="container-fluid pt-nav__interior">

        <Link to="/" className="navbar-brand pt-nav__marca" onClick={closeMenu}>
          <LogoPlato className="pt-nav__logo" />
          <span>Plato tras Plato</span>
        </Link>

        <button
          className="navbar-toggler pt-nav__toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarContent"
          aria-controls="navbarContent"
          aria-expanded="false"
          aria-label="Abrir o cerrar el menú"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">

            <li className="nav-item">
              <NavLink to="/recipes" className={enlace} onClick={closeMenu}>
                Recetas
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink to="/que-cocino" className={enlace} onClick={closeMenu}>
                ¿Qué cocino?
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink to="/contacto" className={enlace} onClick={closeMenu}>
                Contacto
              </NavLink>
            </li>

            {/* La lista de la compra solo se enseña cuando hay algo en ella */}
            {productosCompra > 0 && (
              <li className="nav-item">
                <NavLink to="/compra" className={enlace} onClick={closeMenu}>
                  Compra <span className="pt-nav__cuenta" aria-label={`${productosCompra} productos`}>{productosCompra}</span>
                </NavLink>
              </li>
            )}

            {/* La razón de ser de la web: las guardadas, a un clic desde cualquier página */}
            {user && (
              <li className="nav-item">
                <NavLink to="/infoDatosPersonales#mis-guardadas" className={enlace} onClick={closeMenu}>
                  Mis guardadas
                </NavLink>
              </li>
            )}

            {user?.role === 'admin' && (
              <>
                <li className="nav-item">
                  <NavLink to="/admin" end className={enlace} onClick={closeMenu}>
                    Panel Admin
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to="/admin/users" className={enlace} onClick={closeMenu}>
                    Usuarios
                  </NavLink>
                </li>
              </>
            )}

          </ul>

          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            {user ? (
              <li className="nav-item dropdown" ref={menuUsuario}>
                <button
                  type="button"
                  className="nav-link dropdown-toggle pt-nav__usuario"
                  onClick={toggleDropdown}
                  aria-expanded={dropdownOpen}
                  aria-haspopup="true"
                >
                  {user.username}
                </button>

                {dropdownOpen && (
                  <ul className="dropdown-menu dropdown-menu-end show pt-nav__menu">
                    <li>
                      <Link
                        to="/infoDatosPersonales"
                        className="dropdown-item"
                        onClick={closeMenu}
                      >
                        Mi cuenta
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/changePassword"
                        className="dropdown-item"
                        onClick={closeMenu}
                      >
                        Cambiar contraseña
                      </Link>
                    </li>
                    <li><hr className="dropdown-divider" /></li>
                    <li>
                      <Link
                        to="/logout"
                        className="dropdown-item"
                        onClick={closeMenu}
                      >
                        Cerrar sesión
                      </Link>
                    </li>
                  </ul>
                )}
              </li>
            ) : (
              <>
                <li className="nav-item">
                  <NavLink to="/login" className={enlace} onClick={closeMenu}>Iniciar sesión</NavLink>
                </li>
                <li className="nav-item pt-nav__crear">
                  <Link to="/register" className="pt-nav__crear-enlace" onClick={closeMenu}>
                    Crear cuenta
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default NavBarP;
